import React from 'react';
import { Button, Modal } from 'antd';

function DeleteCountSheetModal({ visible, setVisible, handleDeleteConfirm }) {

  return (
    <Modal
      title='Delete Count Sheet'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      width={400}
      footer={[
        <Button
          onClick={() => setVisible(false)}
          className='Deactivate-Button'
        >
          Cancel
        </Button>,
        <Button
          onClick={handleDeleteConfirm}
        >
          Confirm
        </Button>
      ]}
    >
      <div>Are you sure want to delete this count sheet?</div>
    </Modal>
  )
}

export default DeleteCountSheetModal;
